import {Component, ElementRef, HostListener, Input, OnInit} from '@angular/core';

@Component({
  selector: 'cm-popover',
  template: `
    <span class="popover-wrapper">
      <span (click)="enabled && toggle()">
        <ng-content select="cm-popover-action">
      </ng-content>
      </span>
      <span class="popover" [class.opened]="opened">
        <ng-content select="cm-popover-content"></ng-content>
      </span>
    </span>
  `,
  styleUrls: ['./cm-popover.component.scss']
})
export class CmPopoverComponent implements OnInit {

  opened: boolean;

  @Input()
  enabled = true;

  constructor(private _eref: ElementRef) {
  }

  ngOnInit(): void {

  }

  toggle() {
    this.opened = !this.opened;
  }

  @HostListener('document:click', ['$event'])
  onKeyDown(e: KeyboardEvent) {
    const insideWidget = this._eref.nativeElement.contains(e.target);
    if (!insideWidget) {
      this.opened = false;
    }
  }

}

@Component({
  selector: 'cm-popover-action',
  template: `
    <ng-content></ng-content>`,
  host: {'class': 'cm-popover-action'}
})
export class CmPopoverActionComponent {
}

@Component({
  selector: 'cm-popover-content',
  template: `
    <ng-content></ng-content>`,
  host: {'class': 'cm-popover-content'}
})
export class CmPopoverContentComponent {
}
